<h2 mat-dialog-title>{{this.title}}</h2>
<mat-dialog-content>
    {{this.content}}
</mat-dialog-content>
<mat-dialog-actions  align="center">
  <button class="ok-btn" color="custom-color" mat-raised-button mat-dialog-close cdkFocusInitial>{{this.btnLabel}}</button>
</mat-dialog-actions>